import { Scrollbar, Mobile, Accordion, Tabs, Carousel_CoreInit, Form_CoreInit, AjaxifyGrid_CoreInit, Header_CoreInit, replaceMeta, TRANSITION_END, getTransform } from './core'
import Fancybox from '@fancyapps/fancybox'
import { Swiper } from 'swiper'
import { Navigation, Pagination, EffectFade, Autoplay, FreeMode } from 'swiper'
import Header from './modules/header'
import Vh from './modules/vh'
import Locator from './modules/locator'
import Favorites from './modules/favorites'
import './plugins/forms'
import './plugins/video-player'
import './plugins/scroll-to-anchor'
import './plugins/truncated'
import './plugins/fcmq-map'

$.mlmi = {
  mobile: new Mobile(),
  favorites: undefined,
  suggestionsSwiper: undefined,
}

Header_CoreInit({
  burger_options: {
    onToggle: function() {
      $('.header__main-menu-wrapper').removeClass('--second-level');
      if ($('body').hasClass('--menu-open')) {
        $('body').removeClass('--force-header--scroll-down')
        $('body').removeClass('--force-header--scroll-up')
      }
      var scrolldown = false;
      if ($('body').hasClass('header--scroll-down')) {
        scrolldown = true;
      }
      var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
      if (scrollTop != 0) {
        $('body').css('--scrollTop', scrollTop);
      } else {
        if (!$('body').hasClass('--menu-open')) {
          $('body').css('--scrollTop', 0);
        }
      }
      $('body').css('--top',-scrollTop + 'px');
      window.scrollTo({ top: $('body').css('--scrollTop')});
      if (scrolldown && !$('body').hasClass('--menu-open')) {
        $('body').addClass('--force-header--scroll-down')
      }
      if (!scrolldown && !$('body').hasClass('--menu-open')) {
        $('body').addClass('--force-header--scroll-up')
      }
      $('body').toggleClass('--menu-open --no-scroll')
    },
  }
})

AjaxifyGrid_CoreInit([
  {
    afterUpdate: function(grid) {
      Favorites.buttons(grid)
      Fiches_Init(grid)
    },
  },
])

if ($('.app').find('.schema-graph:not(.fiche .schema-graph)').length) {
  window.rootSchemaGraph = JSON.parse($('.app').find('.schema-graph:not(.fiche .schema-graph)').html())
  window.rootSchemaData = JSON.parse($('.app').find('.schema-data:not(.fiche .schema-data)').html())
}

const Fiches_Init = function(scope) {
  if (scope == undefined) {
    scope = document
  }
  $(scope).find('a.card-event, a.card-location:not(.card--type-grouping), a.card-municipality, .card-panel__cta:not(.card--type-destination .card-panel__cta):not(.card--type-grouping .card-panel__cta), .card-panel__image a:not(.card--type-destination .card-panel__image a):not(.card--type-grouping .card-panel__image), .card-text__cta:not(.card--type-grouping .card-text__cta), .single-article__locations .btn-primary-small').each(function() {
    if (window.location.hostname === 'localhost' && $(this).attr('href').substr(0, 5) === 'https') {
      let cardURL = new URL($(this).attr('href'))
      $(this).attr('href', cardURL.pathname + cardURL.search + cardURL.hash)
    }
    $(this).fancybox({
      backFocus: false,
      touch: false,
      type: 'ajax',
      btnTpl: {
        close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
        '<i class="icon-close"></i>' +
        "</button>",
        smallBtn:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
        '<i class="icon-close"></i>' +
        "</button>",
        arrowLeft: '',
        arrowRight: '',
      },
      helpers   : {
        overlay : {
          closeClick: true
        }
      },
      ajax: {
        settings: {
          data: {
            fragment: 1,
            fancybox: 1,
          },
        },
      },
      onDeactivate: function(instance, current) {
        instance.close()
      },
      afterLoad: function(instance, current) {
        Favorites.buttons(current.$content)
        Accordion.init(current.$content)
        Locator.init(current.$content, true)
        Carousel_Init(current.$content)
        Fiches_Init(current.$content)
        if (current.$content.find('.schema-graph').length) {
          let schemaGraph = JSON.parse(current.$content.find('.schema-graph').html()),
          schemaData = JSON.parse(current.$content.find('.schema-data').html())
          replaceMeta(schemaGraph, schemaData)
          if ('history' in window && location.hostname != 'localhost') {
            if (schemaData.canonical) {
              window.history.pushState({}, document.title, schemaData.canonical)
            } else if (schemaGraph['@graph'][0]['@id'] != undefined) {
              window.history.pushState({}, document.title, schemaGraph['@graph'][0]['@id'])
            }
          }
        }
        current.$content.find('.grid .favorite__toggle').each(function() {
          let content_uid = $(this).attr('data-content-uid')
          if ($.inArray(content_uid, featured_uid) !== -1) {
            $(this).closest('.favorite').before('<div class="featured card-location__featured"><i class="icon-star"></i><span>' + bassaintlaurent_l10n.FEATURED + '</span></div>')
            let grid_item = $(this).closest('.grid__item')
            if (grid_item.length) {
              grid_item.closest('.grid').prepend(grid_item)
            }
          }
        })
        current.$content.find('.js-truncated').each(function() {
          $(this).truncated();
        })
      },
      afterClose: function(instance, current) {
        if (instance.isVisible && 'rootSchemaGraph' in window) { // back to root
          replaceMeta(window.rootSchemaGraph, window.rootSchemaData)
          if ('history' in window && location.hostname != 'localhost') {
            if (rootSchemaData.canonical) {
              window.history.pushState({}, document.title, rootSchemaData.canonical)
            } else if (rootSchemaGraph['@graph'][0]['@id'] != undefined) {
              window.history.pushState({}, document.title, rootSchemaGraph['@graph'][0]['@id'])
            }
          }
        }
      }
    })
  })

  window.addEventListener('popstate', function(event) {
    if ($('.fancybox-is-open').length || $('main > .fiche__container').length) {
      window.location.reload()
    }
  })
}

function Carousel_Init(scope) {
  Carousel_CoreInit([
    {
      classSelector: 'carousel--style--instagram',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: '2',
          },
        },
      },
    },
    {
      classSelector: 'carousel--postitem__location',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: '2',
          },
        },
      },
    },
    {
      classSelector: 'carousel--postitem__article',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: '2',
          },
        },
      },
    },
    {
      classSelector: 'carousel--postitem__municipality',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: '2',
          },
        },
      },
    },
    {
      classSelector: 'carousel--style--full-width',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: '1',
          },
        },
      },
    },
    {
      classSelector: 'carousel--postitem__suggestion',
      swiperOptions: {
        loopAdditionalSlides: 4,
        breakpoints: {
          0: {
            slidesPerView: '2',
          },
        },
        freeMode: {
          enabled: true,
          sticky: false,
        },
        loop: true,
        speed: 3000,
        allowTouchMove: false,
        threshold: 50,
        autoplay: {
          delay: 0,
        },
        on: {
          afterInit: function(swiper) {
            $.mlmi.suggestionsSwiper = swiper
            $.mlmi.suggestionsRunning = 3
          },
        }
      },
    },
  ], scope)
}
Carousel_Init();

function suggestionsPause() {
  if ($.mlmi.suggestionsSwiper == undefined) {
    return
  }
  if ($.mlmi.suggestionsRunning === 1) {
    return
  }
  clearTimeout($.mlmi.suggestionsTimeout)
  let targetTransform = getTransform($('.grid--postitem__suggestion').get(0)) + '',
  targetX = parseFloat(targetTransform.split(',')[0]),
  currentTransform = getComputedStyle($('.grid--postitem__suggestion').get(0)).transform + '',
  currentX = Math.round(parseFloat(currentTransform.split(',')[4]))
  $.mlmi.suggestionsSwiper.autoplay.stop()
  $.mlmi.suggestionsSwiper.params.speed = 100
  $.mlmi.suggestionsSwiper.update()
  $.mlmi.suggestionsDelta = currentX - targetX
  $.mlmi.suggestionsTarget = targetX
  $('.grid--postitem__suggestion').css({
    transform: 'translate3d(' + currentX + 'px, 0px, 0px)',
  })
  $.mlmi.suggestionsRunning = 1
}

function suggestionsPlay() {
  if ($.mlmi.suggestionsSwiper == undefined) {
    return
  }
  $.mlmi.suggestionsRunning = 2
  let totalWidth = $('.grid--postitem__suggestion .grid__item').outerWidth(true)
  let deltaDuration = Math.round(3000 * $.mlmi.suggestionsDelta / totalWidth)
  $('.grid--postitem__suggestion').css({
    'transform': 'translate3d(' + $.mlmi.suggestionsTarget + 'px, 0px, 0px)',
    'transition-duration': deltaDuration + 'ms',
  })
  clearTimeout($.mlmi.suggestionsTimeout)
  $.mlmi.suggestionsTimeout = setTimeout(function() {
    $.mlmi.suggestionsSwiper.params.speed = 3000
    $.mlmi.suggestionsSwiper.update()
    $.mlmi.suggestionsSwiper.autoplay.start()
    $.mlmi.suggestionsRunning = 3
  }, deltaDuration)
}

Form_CoreInit([
  {
    classSelector: 'builder-form',
    formOptions: {
      floating_labels: true,
    },
  },
  {
    classSelector: 'builder-form--brochures',
    formOptions: {
      onInit: function(form) {
        form.BrochuresForm()
      },
      onSuccess: function(x, form) {
        if ($.mlmi.mobile.isMobile && $('.formulaire-brochures-sm').length) {
          $('html, body').scrollTo($('.formulaire-brochures-sm').offset().top - 115, 425, 5, 'easeInOutQuart')
        } else if (!$.mlmi.mobile.isMobile && $('.formulaire-brochures-md').length) {
          $('html, body').scrollTo($('.formulaire-brochures-md').offset().top - 150, 425, 5, 'easeInOutQuart')
        }
      },
    }
  }
])

$(function() {
  Header.init()

  Accordion.init()

  Tabs.init({
    changeHash: false,
  })

  if ('locations' in window && window.locations.length > 0) {
    Locator.init('.app', false)
  }

  Favorites.init()

  /* Make sure vh works on ios */
  Vh.init()

  /* Truncated */
  $('.js-truncated').each(function() {
    $(this).truncated();
  })

  /* Buttons */
  $('.text-content a:not(.btn-primary):not(.btn-secondary):not(.btn-primary-small):not(.social-icons__link)').each(function() {
    $(this).contents().wrap('<span/>');
  })

  /* Video player */
  $('.video-loop').each(function() {
    $(this).VideoLoop()
    if ($(this).closest('.video-player').length) {
      $(this).closest('.video-player').VideoPlayer()
    }
  })

  /* Scrollbars */
  $('.map__menu').each(function() {
    let content_results = new Scrollbar($(this), {
      direction: 'vertical',
      desktop: true,
      mobile: true,
    })
  })

  /* Scroll to anchor */
  $('a[href^="#"]').each(function() {
    $(this).scrollToAnchor();
  })

  $('.grid-filters .select__options li').each(function() {
    $(this).html($(this).html().replace(/\[(.+?)\]/, '<span>($1)</span>'))
  })

  /* Intro slides */
  $('.--has-extra-diapositive').each(function() {
    let self = $(this);
    self.find('.--intro-slide').clone().attr('style', '').addClass('--mobile').insertBefore( self );
  })

  /* FCQM MAP */
  $('.fcmq-map').each(function() {
    $(this).fcmqMap();
  })

  /* Fancybox */
  $('.card-youtube').fancybox({
    backFocus: false,
    baseClass : 'fancybox-video-content',
    fitToView:  true,
    autoSize:   true,
    btnTpl: {
      close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="icon-close"></i>' +
      "</button>",
      smallBtn:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="icon-close"></i>' +
      "</button>",
      arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<div><i class="icon-arrow-left"></i></div>' +
      "</button>",
      arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<div><i class="icon-arrow-right"></i></div>' +
      "</button>",
    },
    hash : false,
  })

  $('.fadein').each(function() {
    $(this).FadeIn()
  })

  Fiches_Init()
  $.mlmi.Fiches_Init = Fiches_Init
  $('.card-suggestion').fancybox({
    backFocus: false,
    baseClass : 'fancybox-suggestion-content',
    type:       'ajax',
    maxHeight:  100,
    fitToView:  true,
    autoSize:   true,
    ajax: {
      settings: {
        data: {
          fragment: 1,
          fancybox: 1,
        },
      },
    },
    btnTpl: {
      close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="icon-close"></i>' +
      "</button>",
      smallBtn:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="icon-close"></i>' +
      "</button>",
      arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<div><i class="icon-arrow-left"></i></div>' +
      "</button>",
      arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<div><i class="icon-arrow-right"></i></div>' +
      "</button>",
    },
    hash : false,
    beforeShow: function(instance, current) {
      requestAnimationFrame(suggestionsPause)
    },
    afterShow: function( instance, current ) {
      $('.fancybox-suggestion-content .video-loop').VideoLoop()
      $('.fancybox-suggestion-content .video-player').VideoPlayer()
      var swiper = new Swiper(".suggestion-gallery", {
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    },
    afterClose: function() {
      suggestionsPlay()
    },
  })

  $('.--video-playlist').VideoPlaylist();

  $('.gallery__image').fancybox({
    backFocus: false,
    type: 'image',
    maxHeight: 80,
    fitToView: true,
    autoSize: true,
    buttons: [
      //"zoom",
      //"share",
      //"slideShow",
      //"fullScreen",
      //"download",
      //"thumbs",
      "close"
    ],
    btnTpl: {
      close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="icon-close"></i>' +
      "</button>",
      smallBtn:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="icon-close"></i>' +
      "</button>",
      arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<div><i class="icon-arrow-left"></i></div>' +
      "</button>",
      arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<div><i class="icon-arrow-right"></i></div>' +
      "</button>",
    },
    hash : false,
  })

  $('.carousel--postitem__suggestion .card-suggestion').on('mouseup', function() {
    $(this).click()
  })
  $('.carousel--postitem__suggestion').on('mouseenter', function() {
    suggestionsPause()
  })
  $('.carousel--postitem__suggestion').on('mouseleave', function() {
    suggestionsPlay()
  })

  /* Center grid exception */
  $('.grid--col-4.grid--postitem__municipality').each(function() {
    if ($(this).find('.grid__item:not(.ajax-load-more):not(.ajax-load-more__end-page)').length <= 2) {
      $(this).addClass('grid--centered-' + $(this).find('.grid__item:not(.ajax-load-more):not(.ajax-load-more__end-page)').length)
    }
  })

  /* Captions */
  $('figure:not(.mlmi-blockquote)').each(function() {
    $(this).find('figcaption').after('<button class="figcaption__toggle"><i class="icon-image"></i></button>');
    $(this).find('.figcaption__toggle, figcaption').click(function() {
      $(this).closest('figure').toggleClass('--open');
      return false;
    })
  })

  /* Load dynamic content */
  if ($('.banner-row').length) {
    $.ajax({
      url: '/dynamic/',
      method: 'POST',
      data: {
        'action': 'get_dynamic',
        'format': $.mlmi.mobile.isMobile ? 'sm' : 'md',
        'language': bassaintlaurent_l10n.LANGUAGE,
        'groups': $('.banner-row:eq(0)').data('groups'),
      },
      success: function(response) {
        response = $('<div>').append(response)
        response.find('.banner-row').each(function() {
          let newBanner = $(this)
          $('.banner-row').replaceWith(newBanner)
        })
      },
    })
  }
})
